var _rect, _rect2, _rect3, _path, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCardCvv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 94,
    viewBox: "0 0 154 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 152,
    height: 92,
    rx: 5,
    stroke: "#EEEDEE",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 152,
    height: 20,
    fill: "#EEEDEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 50,
    width: 88,
    height: 20,
    rx: 3,
    fill: "#EEEDEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.676 65.154C108.584 65.154 107.693 64.7853 107.002 64.048C106.311 63.3107 105.966 62.368 105.966 61.22V58.812C105.966 57.6733 106.311 56.7353 107.002 55.998C107.693 55.2607 108.584 54.892 109.676 54.892C110.759 54.892 111.645 55.2607 112.336 55.998C113.027 56.7353 113.372 57.6733 113.372 58.812V61.22C113.372 62.368 113.027 63.3107 112.336 64.048C111.645 64.7853 110.759 65.154 109.676 65.154ZM108.374 62.718C108.701 63.082 109.135 63.264 109.676 63.264C110.217 63.264 110.647 63.082 110.964 62.718C111.291 62.354 111.454 61.8547 111.454 61.22V58.812C111.454 58.1773 111.291 57.6827 110.964 57.328C110.647 56.964 110.217 56.782 109.676 56.782C109.135 56.782 108.701 56.964 108.374 57.328C108.047 57.6827 107.884 58.1773 107.884 58.812V61.22C107.884 61.8547 108.047 62.354 108.374 62.718ZM119.508 65.154C118.416 65.154 117.525 64.7853 116.834 64.048C116.143 63.3107 115.798 62.368 115.798 61.22V58.812C115.798 57.6733 116.143 56.7353 116.834 55.998C117.525 55.2607 118.416 54.892 119.508 54.892C120.591 54.892 121.477 55.2607 122.168 55.998C122.859 56.7353 123.204 57.6733 123.204 58.812V61.22C123.204 62.368 122.859 63.3107 122.168 64.048C121.477 64.7853 120.591 65.154 119.508 65.154ZM118.206 62.718C118.533 63.082 118.967 63.264 119.508 63.264C120.049 63.264 120.479 63.082 120.796 62.718C121.123 62.354 121.286 61.8547 121.286 61.22V58.812C121.286 58.1773 121.123 57.6827 120.796 57.328C120.479 56.964 120.049 56.782 119.508 56.782C118.967 56.782 118.533 56.964 118.206 57.328C117.879 57.6827 117.716 58.1773 117.716 58.812V61.22C117.716 61.8547 117.879 62.354 118.206 62.718ZM129.34 65.154C128.248 65.154 127.357 64.7853 126.666 64.048C125.975 63.3107 125.63 62.368 125.63 61.22V58.812C125.63 57.6733 125.975 56.7353 126.666 55.998C127.357 55.2607 128.248 54.892 129.34 54.892C130.423 54.892 131.309 55.2607 132 55.998C132.691 56.7353 133.036 57.6733 133.036 58.812V61.22C133.036 62.368 132.691 63.3107 132 64.048C131.309 64.7853 130.423 65.154 129.34 65.154ZM128.038 62.718C128.365 63.082 128.799 63.264 129.34 63.264C129.881 63.264 130.311 63.082 130.628 62.718C130.955 62.354 131.118 61.8547 131.118 61.22V58.812C131.118 58.1773 130.955 57.6827 130.628 57.328C130.311 56.964 129.881 56.782 129.34 56.782C128.799 56.782 128.365 56.964 128.038 57.328C127.711 57.6827 127.548 58.1773 127.548 58.812V61.22C127.548 61.8547 127.711 62.354 128.038 62.718Z",
    fill: "#7C777F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 49,
    width: 35,
    height: 22,
    rx: 3,
    stroke: "#E34646",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCardCvv);
export default __webpack_public_path__ + "static/media/ic_card_cvv.6b367a2086d435620fc11471e61c60a6.svg";
export { ForwardRef as ReactComponent };